import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useCustomerAuth } from '../contexts/CustomerAuthContext';
import { Home, User, LogOut, Trophy, ClipboardList } from 'lucide-react';

export default function CustomerNavBar() {
  const { customer, logout, isAuthenticated } = useCustomerAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Don't show on login page
  if (location.pathname === '/login' || !isAuthenticated) {
    return null;
  }

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (p) => location.pathname === p || location.pathname.startsWith(p + '/');

  return (
    <div className="bg-gradient-to-r from-violet-600 via-purple-600 to-fuchsia-600 text-white shadow-lg sticky top-0 z-50">
      <div className="px-4 py-3">
        <div className="flex items-center justify-between gap-2">
          {/* Left - Home + Tournaments */}
          <div className="flex items-center gap-2">
            <Link
              to="/"
              className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/20 hover:bg-white/30 transition-colors"
              data-testid="home-btn"
            >
              <Home className="w-4 h-4" />
              <span className="text-sm font-medium hidden sm:inline">Home</span>
            </Link>
            <Link
              to="/events"
              className={`flex items-center gap-2 px-3 py-1.5 rounded-full transition-colors ${isActive('/events') ? 'bg-white text-violet-700' : 'bg-white/10 hover:bg-white/20'}`}
              data-testid="nav-tournaments-btn"
            >
              <Trophy className="w-4 h-4" />
              <span className="text-sm font-medium">Tournaments</span>
            </Link>
            <Link
              to="/my-registrations"
              className={`flex items-center gap-2 px-3 py-1.5 rounded-full transition-colors ${isActive('/my-registrations') ? 'bg-white text-violet-700' : 'bg-white/10 hover:bg-white/20'}`}
              data-testid="nav-my-registrations-btn"
            >
              <ClipboardList className="w-4 h-4" />
              <span className="text-sm font-medium hidden sm:inline">My Registrations</span>
            </Link>
          </div>

          {/* Right - User Info */}
          <div className="flex items-center gap-2">
            <Link
              to="/profile"
              className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/20 transition-colors"
              data-testid="nav-profile-btn"
            >
              <div className="w-6 h-6 rounded-full bg-white/30 flex items-center justify-center text-xs font-bold">
                {customer?.name?.charAt(0)?.toUpperCase() || 'U'}
              </div>
              <span className="text-sm font-medium max-w-[80px] truncate hidden sm:inline">
                {customer?.name || 'User'}
              </span>
            </Link>
            <button
              onClick={handleLogout}
              className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors"
              data-testid="nav-logout-btn"
              title="Logout"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
